package com.sweetlime.bingeamigo.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class MovieDetail(
    val id: Int,
    val title: String,
    val overview: String,
    val adult: Boolean = false,
    @SerialName("backdrop_path")
    val backdropPath: String? = null,
    val genres: List<Genre> = emptyList(),
    @SerialName("original_language")
    val originalLanguage: String = "",
    @SerialName("original_title")
    val originalTitle: String = "",
    val popularity: Double = 0.0,
    @SerialName("poster_path")
    val posterPath: String? = null,
    @SerialName("release_date")
    val releaseDate: String = "",
    val video: Boolean = false,
    @SerialName("vote_average")
    val voteAverage: Double = 0.0,
    @SerialName("vote_count")
    val voteCount: Int = 0,
    val runtime: Int = 0,
    val tagline: String = "",
    val status: String = ""
)

fun MovieDetail.toMovie() = Movie(
    id = id,
    title = title,
    overview = overview,
    adult = adult,
    backdropPath = backdropPath,
    genreIds = genres.map { it.id },
    originalLanguage = originalLanguage,
    originalTitle = originalTitle,
    popularity = popularity,
    posterPath = posterPath,
    releaseDate = releaseDate,
    video = video,
    voteAverage = voteAverage,
    voteCount = voteCount
)

fun MovieDetail.toLibraryMovie() = LibraryMovie(id = id, movie = toMovie())